export default {"src":"/_next/static/media/Google_play.fee9394c.svg","height":57,"width":185,"blurWidth":0,"blurHeight":0};